<template lang="pug">
article.media(@click="openPodcast")
  figure.media-left.image
    font-awesome-icon.highlight(:icon="['fas', 'play-circle']", size="4x")
  .media-content
    .content
      p {{ podcast.title }}
      p.is-size-7 {{ podcast.date }}
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons";

library.add(faPlayCircle);

export default {
  name: "PodcastEpisode",

  props: ["podcast"],

  methods: {
    openPodcast() {
      window.open(this.podcast.link, "__blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.highlight {
  -webkit-filter: brightness(100%);
  color: #7957d5;
}

.highlight:hover {
  color: #7957d5;
  -webkit-filter: brightness(70%);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
  cursor: pointer;
}
</style>
